 function init() {
     initScrollHeader();
     initMobileMenu();
     initTestimonialsSlider();
     initProjectsSlider();
     initAccordion();
     handleResponsive();
     window.addEventListener('resize', handleResponsive);
 }

 // --- Accordion ---
 function initAccordion() {
     document.querySelectorAll('[data-accordion]').forEach(function(accordion) {
         accordion.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
             trigger.addEventListener('click', function() {
                 var item    = trigger.closest('[data-accordion-item]');
                 var content = item.querySelector('[data-accordion-content]');
                 var isOpen  = trigger.getAttribute('aria-expanded') === 'true';

                 // Close all siblings
                 accordion.querySelectorAll('[data-accordion-item]').forEach(function(sibling) {
                     var sibTrigger = sibling.querySelector('[data-accordion-trigger]');
                     var sibContent = sibling.querySelector('[data-accordion-content]');
                     sibTrigger.setAttribute('aria-expanded', 'false');
                     sibTrigger.setAttribute('data-state', 'closed');
                     sibContent.style.maxHeight = '0';
                 });

                 // Open clicked if it was closed
                 if (!isOpen) {
                     trigger.setAttribute('aria-expanded', 'true');
                     trigger.setAttribute('data-state', 'open');
                     content.style.maxHeight = content.scrollHeight + 'px';
                 }
             });
         });
     });
 }

 // --- Mobile menu toggle ---
 function initMobileMenu() {
     const toggle = document.querySelector('[data-mobile-menu-toggle]');
     const menu   = document.querySelector('[data-mobile-menu]');

     if (!toggle || !menu) return;

     const bar1 = toggle.querySelector('[data-bar-1]');
     const bar2 = toggle.querySelector('[data-bar-2]');
     const bar3 = toggle.querySelector('[data-bar-3]');

     function openMenu() {
         menu.classList.remove('hidden');
         toggle.setAttribute('aria-expanded', 'true');
         // Animate to X
         if (bar1) { bar1.style.transform = 'translateY(8px) rotate(45deg)'; }
         if (bar2) { bar2.style.opacity = '0'; }
         if (bar3) { bar3.style.transform = 'translateY(-8px) rotate(-45deg)'; }
     }

     function closeMenu() {
         menu.classList.add('hidden');
         toggle.setAttribute('aria-expanded', 'false');
         if (bar1) { bar1.style.transform = ''; }
         if (bar2) { bar2.style.opacity = ''; }
         if (bar3) { bar3.style.transform = ''; }
     }

     toggle.addEventListener('click', () => {
         menu.classList.contains('hidden') ? openMenu() : closeMenu();
     });

     // Close on nav link click
     menu.querySelectorAll('a').forEach(link => {
         link.addEventListener('click', closeMenu);
     });

     // Close on resize to desktop
     window.addEventListener('resize', () => {
         if (window.innerWidth >= 768) closeMenu();
     });
 }

 // --- Scroll header effect ---
 function initScrollHeader() {
     const header = document.getElementById('site-header');
     if (!header) return;

     const scrolledClasses = ['backdrop-blur-md', 'shadow-sm', 'border-b', 'border-border', 'bg-background/80'];

     function onScroll() {
         if (window.scrollY > 20) {
             header.classList.add(...scrolledClasses);
             header.classList.remove('bg-transparent');
         } else {
             header.classList.remove(...scrolledClasses);
             header.classList.add('bg-transparent');
         }
     }

     window.addEventListener('scroll', onScroll, { passive: true });
     onScroll();
 }

 // --- Testimonials slider ---
 function initTestimonialsSlider() {
     const slides = document.querySelectorAll('.testimonial-slide');
     const dots = document.querySelectorAll('.testimonial-dot');
     const prevBtn = document.getElementById('testimonial-prev');
     const nextBtn = document.getElementById('testimonial-next');

     if (!slides.length || !prevBtn || !nextBtn) return;

     let current = 0;
     const total = slides.length;

     function goTo(index) {
         // hide current
         slides[current].classList.add('hidden');
         dots[current].classList.remove('bg-primary', 'w-6');
         dots[current].classList.add('bg-border', 'w-2');

         // show next
         current = (index + total) % total;
         slides[current].classList.remove('hidden');
         dots[current].classList.remove('bg-border', 'w-2');
         dots[current].classList.add('bg-primary', 'w-6');
     }

     prevBtn.addEventListener('click', () => goTo(current - 1));
     nextBtn.addEventListener('click', () => goTo(current + 1));

     dots.forEach((dot, i) => {
         dot.addEventListener('click', () => goTo(i));
     });

     // Auto-advance every 6s
     setInterval(() => goTo(current + 1), 6000);
 }

 function initProjectsSlider() {
     const slider = document.getElementById('projectsSlider');
     const prevBtn = document.getElementById('prevBtn');
     const nextBtn = document.getElementById('nextBtn');

     if (!slider || !prevBtn || !nextBtn) return;

     let currentPosition = 0;
     const items = document.querySelectorAll('.project-card');
     const itemWidth = 330;

     prevBtn.addEventListener('click', prevProject);
     nextBtn.addEventListener('click', nextProject);

     function nextProject() {
         if (currentPosition > -(items.length - 3) * itemWidth) {
             currentPosition -= itemWidth;
             slider.style.transform = `translateX(${currentPosition}px)`;
         }
     }

     function prevProject() {
         if (currentPosition < 0) {
             currentPosition += itemWidth;
             slider.style.transform = `translateX(${currentPosition}px)`;
         }
     }
 }

 function handleResponsive() {
     const slider = document.getElementById('projectsSlider');
     if (!slider) return;

     if (window.innerWidth <= 768) {
         slider.style.transform = 'translateX(0)';
     }
 }

 export default {init}
